<template>
    <div class="max-width-content">
        <trashed-message v-if="blog.deleted_at" class="mb-6">
            This blog has been deleted.
        </trashed-message>

        <div class="flex items-center justify-between">
            <breadcrumbs>
                <inertia-link :href="route('admin.blogs.index')">Blog</inertia-link>
                <i class="fad fa-chevron-right"></i>
                {{ blog.title | truncate(35) }}
            </breadcrumbs>

            <div v-if="!blog.deleted_at">
                <link-button :href="route('admin.blogs.edit', blog.id)" icon="pencil" class="bg-white">Wijzig</link-button>
                <confirm-button method="delete" :href="route('admin.blogs.destroy', blog.id)" icon="trash" class="bg-white hover:bg-red-600 hover:text-white">Verwijder</confirm-button>
            </div>
        </div>

        <h1 class="text-5xl text-teal-800 mr-1 leading-tight mt-3 mb-3">{{ blog.title }}</h1>

        <div class="bg-white px-3 py-1 rounded-lg">
        <tag-select
                :tags="tags"
                :tags-selected="blog.tags"
                :loading="loading"
                @tag-added="addTag"
                @tag-removed="removeTag"
        ></tag-select>
        </div>

        <div class="bg-gray-400 mt-5">
            <img :src="blog.imgLarge" class="object-cover w-full" />
        </div>

        <div class="styled-content">
            <div v-if="blog.intro" v-html="blog.intro" class="intro"></div>

            <div v-if="blog.body" v-html="blog.body"></div>
        </div>
    </div>
</template>

<script>
import Layout from "@/admin/Shared/Layout";
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import Breadcrumbs from "@/admin/Shared/Breadcrumbs";
import TrashedMessage from "@/admin/Shared/TrashedMessage";
import LinkButton from "@/admin/Shared/LinkButton";
import ConfirmButton from "@/admin/Shared/ConfirmButton";
import TagSelect from "@/admin/Components/TagSelect";

export default {
    layout: Layout,

    mixins: [Helpers],

    components: { Breadcrumbs, TrashedMessage, LinkButton, ConfirmButton, TagSelect },

    props: {
        blog: {
            Type: Object
        },
        tags: Array
    },
    data() {
        return {};
    },
    methods: {

        addTag(tag) {
            this.loading = "addTag";

            const url = this.route("admin.blogs.tags.store", this.blog.id);
            const data = { tagId: tag.id }
            const options = {
                preserveState: true,
                preserveScroll: true,
                onFinish: () => {
                    this.tag = ""
                    this.loading = ""
                }
            }

            this.$inertia.post(url, data, options)
        },

        removeTag(tag) {
            this.loading = "removeTag"+tag.id;

            const url = this.route("admin.blogs.tags.destroy", this.blog.id) + "?tagId=" + tag.id;
            const options = {
                preserveState: true,
                preserveScroll: true,
                onFinish: () => this.loading = false
            };

            this.$inertia.delete(url, options)
        },

    },

    metaInfo() {
        return { title: this.blog.title + " | Voorvertoning" };
    }
};
</script>
